var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "currentcolor",
      color: "currentcolor",
      width: 18,
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.179 18.452c-1.808 2.114-3.927 4.591-6.117 7.152-0.302 0.475-0.91 0.678-1.437 0.453-0.501-0.214-0.728-0.187-0.926 0.010-0.258 0.258-0.196 0.626 0.355 1.177l1.7 1.7c0.554 0.554 0.916 0.616 1.177 0.355 0.209-0.209 0.24-0.428 0.045-0.897-0.21-0.504-0.030-1.079 0.402-1.39l-0.002-0.003 7.162-6.199-2.36-2.36zM11.924 17.581l2.481 2.481 2.034-1.76c2.795-2.419 2.795-2.419 3.293-2.845l9.346-9.38c0.407-0.408 0.393-1.107-0.059-1.56l-1.616-1.616c-0.453-0.453-1.15-0.465-1.557-0.057l-9.31 9.345c0.007-0.007-1.859 2.175-4.611 5.392zM8.356 28.321c0.174 0.972-0.088 1.876-0.808 2.596-1.321 1.321-3.088 1.020-4.436-0.328l-1.7-1.7c-1.346-1.346-1.645-3.12-0.328-4.436 0.724-0.724 1.637-0.973 2.626-0.782 9-10.525 11.15-13.039 11.209-13.098l9.31-9.345c1.311-1.316 3.454-1.279 4.787 0.054l1.616 1.616c1.332 1.332 1.374 3.479 0.062 4.795-5.711 5.732-5.711 5.732-9.408 9.438l-12.93 11.19zM6.924 13.479c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4zM6.924 12.336c1.578 0 2.857-1.279 2.857-2.857s-1.279-2.857-2.857-2.857c-1.578 0-2.857 1.279-2.857 2.857s1.279 2.857 2.857 2.857z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.a414e535b5b710e3367d9006a7b00f6d.svg";
export { ForwardRef as ReactComponent };